import * as React from 'react';
import { Link } from 'react-router-dom';
import { ExternalUrlConstants as urls, LoginConstants as ui } from '../../Config/UIConstants';
import { Routes } from '../../_controllers/RouteController';

export const AcceptTos = () => {
    return (
        <div className="auth-page__fine-print">
            <p>
                {ui.TOS_PREFIX} <a href={urls.PRIVACY_POLICY_URL} target="_blank" rel="noopener">{ui.PRIVACY_POLICY}</a> and <a href={urls.TOS_URL} target="_blank" rel="noopener">{ui.TOS}</a></p>
            <p>
                "Free for Life" <Link to={Routes.FREE_FOR_LIFE_PROMOTION}>Promotion Rules</Link>
            </p>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/Pages/AuthPages/AcceptTos.tsx